import React, { useState } from 'react'
import './ContactCard.scoped.sass'
import classNames from 'classnames'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import NameSlugPlaceholder from '@/pages/HomePage/FeedContent/Thread/CardMainSection/MainSectionHeader/NameSlugPlaceholder'
import commonsService from '@/services/commons.service'
import modalService from '@/services/modal.service'
import CreateContactModal from '../../../CreateContactModal/CreateContactModal'

const ContactCard = (props) => {
  const { selectContact, isActive, setChosenContact, markContact } = props
  const [contact, setContact] = useState(props.contact)
  const [isMarked, setIsMarked] = useState(false)

  useRenderEvent([`CONTACT:${contact.id}:UPDATED`], (contact) => {
    setContact(contact)
  })

  return (
    <div className='main-container' onClick={() => {
      if (commonsService.isMobile()) {
        modalService.open(<CreateContactModal type='edit' contact={contact} />, true)
      } else {
        selectContact()
        setChosenContact(contact)
      }
    }}>
      <div className={classNames('list-item-container', {
        active: isActive
      })}>
        <li className='list-item'>
          <div className="card-left">
            <span className='card-icon'>
              { contact?.contactimageuri
                ? <img className='contact-image-img' src={contact.contactimageuri}/>
                : <NameSlugPlaceholder name={
                (contact.firstname || contact.lastname) ? (contact.firstname || '') + ' ' + (contact.lastname || '') : '-'
              }/>
              }
            </span>
          </div>
          <div className="card-right">
            <div className="card-right-top" title={(contact.firstname || '') + ' ' + (contact.lastname || '')}>{(contact.firstname || '') + ' ' + (contact.lastname || '')}</div>
            <div className="card-right-bottom" title={contact.emails && contact.emails[0]}>{contact.emails && contact.emails[0]}</div>
          </div>
          <div className={classNames('mark-box', { active: isMarked === true })}>
            <input type='checkbox' checked={isMarked} onClick={(e) => {
              e.stopPropagation()
              setIsMarked(!isMarked)
              markContact(contact)
            }}/>
          </div>
        </li>
      </div>
    </div>
  )
}

export default ContactCard
